import { Message } from 'modules/chat/types/Message';
import { AutomatedValidationStatus, SelfServiceType } from 'modules/selfServices/types/SelfService';

export enum SocketResponseAction {
  KIOSK_ONLINE = 'KIOSK_ONLINE',
  KIOSK_OFFLINE = 'KIOSK_OFFLINE',
  INTERVENTION_UPDATE = 'INTERVENTION_UPDATE',
  KIOSK_PAYMENT_UPDATE = 'KIOSK_PAYMENT_UPDATE',
  KIOSK_OPERATION_UPDATE = 'KIOSK_OPERATION_UPDATE',
  MESSAGE_SENT = 'MESSAGE_SENT',
  MESSAGE_REACTION_REACT = 'MESSAGE_REACTION_REACT',
  MESSAGE_REACTION_UNREACT = 'MESSAGE_REACTION_UNREACT',
  KIOSK_ALARM_ENTERED = 'KIOSK_ALARM_ENTERED',
  KIOSK_ALARM_EXITED = 'KIOSK_ALARM_EXITED',
}

type MobilityDocumentSocketData = {
  id: string;
  fraud: boolean;
  errors?: string[];
  medias: { uploadId: string }[];
};

export interface ResponseData {
  id: string;
  eventId: string;
  updatedMedia: boolean;
  updatedExtras: boolean;
  updatedComment: boolean;
  updatedParking: boolean;
  updatedPayment: boolean;
  updatedWorksDone: boolean;
  checkOutCompleted: boolean;
  paymentInProgress: boolean;
  updatedQuestionForm: boolean;
  updatedFinalInvoice: boolean;
  vehicleCheckStarted: boolean;
  updatedProactiveWorks: boolean;
  updatedInterventionMedias: boolean;
  validationStatus?: AutomatedValidationStatus;
  mobility?: {
    documents: MobilityDocumentSocketData[];
  };
}

export interface SocketResponseUpdate<T = ResponseData> {
  action: SocketResponseAction;
  createdOn: string;
  entityId: string;
  data: T;
}

type SocketResponse = SocketResponseUpdate | { status: number } | string;


export const isSocketResponseUpdate = (response: SocketResponse): response is SocketResponseUpdate => (response as SocketResponseUpdate).action !== undefined;

interface KioskResponse<T> extends SocketResponseUpdate<T> {
  isSuccess: boolean;
}

export type KioskPaymentUpdate = KioskResponse<{
  canceled: boolean;
  refused: boolean;
  timeout: boolean; // true if the lambda timeout after a while (100s or 300s without interaction)
  providerError: boolean; // true for the rest of the errors coming from the provider
  hostUnavailable: boolean; // true if the provider is in error and have the specific error of the host unavailable
}>;

export enum QrCodeActionType {
  LOGIN = 'LOGIN',
  TEST_FACTORY = 'TEST_FACTORY',
}

export type QrCodeLoginPayload = { code: string; type: SelfServiceType };
export type QrCodeTestFactoryPayload = { messageId: string };

type QrCodeNewData =
  | { type: QrCodeActionType.LOGIN; payload: QrCodeLoginPayload }
  | { type: QrCodeActionType.TEST_FACTORY; payload: QrCodeTestFactoryPayload };

type QrCodeLegacyData = { code?: string; type?: SelfServiceType };

export type QrCodeAdditionalData = QrCodeNewData | QrCodeLegacyData;

export type KioskOperationUpdate = KioskResponse<{
  doorClosed: boolean;
  doorOpened: boolean;
  doorPrepared: boolean;
  qrCodeScanned: boolean;
  doorCloseFailed: boolean;
  doorOpenedFailed: boolean;
  doorPreparedFailed: boolean;
  additionalData: QrCodeAdditionalData;
}>;

export type IncomingMessage = KioskResponse<{
  message: Message
}>;
